module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#health",
      toString: function () {
        return this.url;
      }
    }